import { create } from "zustand";
import type { IGetConfigResponse } from "@typing/wsui/getConfig";

/**
 * 配置数据状态管理 Store
 * 用于缓存 getConfig 接口返回的全局配置信息
 */
interface IConfigStore {
    // ========== 配置数据 ==========
    config: IGetConfigResponse | null; // 缓存的配置数据
    loading: boolean; // 是否正在加载配置
    error: Error | null; // 加载失败的错误信息

    // ========== 配置数据操作 ==========
    setConfig: (config: IGetConfigResponse) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: Error | null) => void;
    clearConfig: () => void;
}

/**
 * 配置数据状态管理 Hook
 */
export const useConfigStore = create<IConfigStore>((set) => ({
    // ========== 配置数据 ==========
    config: null,
    loading: false,
    error: null,

    // ========== 配置数据操作 ==========
    /**
     * 设置配置数据
     * @param config - 配置数据对象
     */
    setConfig: (config: IGetConfigResponse) => {
        set({ config, error: null });
    },

    /**
     * 设置加载状态
     * @param loading - 是否正在加载
     */
    setLoading: (loading: boolean) => {
        set({ loading });
    },

    /**
     * 设置错误信息
     * @param error - 错误对象
     */
    setError: (error: Error | null) => {
        set({ error, loading: false });
    },

    /**
     * 清除配置数据
     * 用于登出或需要重新获取配置时
     */
    clearConfig: () => {
        set({ config: null, error: null, loading: false });
    },
}));